import { Link } from 'react-router-dom';
import styled from 'styled-components';
import Paper from '@material-ui/core/Paper';
import MainLayout, { InnerContainer } from './MainLayout';

const StyledPaper = styled(Paper)`
    height: 200px;
    width: 300px;
    background: #777777;
    color: ${(props) => (props.disabled ? '#aaaaaa' : '#ffffff')};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    text-decoration: none;
    margin: 16px;
    /* flex-basis: calc(33% - 32px); */
    box-sizing: content-box;
`;

const LinkContainer = styled.div`
    display: flex;
`;

const LinkTile = (props) => (
    <StyledPaper
        to="/map"
        component={props.disabled ? 'div' : Link}
        elevation={3}
        {...props}
    />
);

const Home = () => {
    return (
        <MainLayout>
            <InnerContainer>
                <LinkContainer>
                    <LinkTile key="master" to={'/master'}>
                        <div>master</div>
                    </LinkTile>
                    <LinkTile key="student" to={'/student'}>
                        <div>student</div>
                    </LinkTile>
                </LinkContainer>
            </InnerContainer>
        </MainLayout>
    );
};
export default Home;
